import React from 'react';

import { Direction } from '@prisjakt/ui';
import { IconMenuKebab } from '@prisjakt/ui/icon/menu-kebab';
import { ButtonIcon, ButtonSize, ButtonType } from '@prisjakt/ui/button';
import { DesktopOnly, MediumDown } from 'src/ui/block';
import { Row } from '@prisjakt/ui/list/variants';
import {
  Dropdown,
  DropdownContent,
  DropdownToggle,
} from '@prisjakt/ui/dropdown';

import { zindex } from 'src/ui/zindex';

import { ListContainer } from './styles';

type Props = {
  children?: React.ReactNode;
};

export const ItemContainer = (props: Props) => {
  const { children } = props;

  return (
    <>
      {/* Action buttons with dropdown, (smaller devices) */}
      <MediumDown>
        <Dropdown
          style={{ height: 'fit-content' }}
          zIndex={zindex.actionButtonDropdown}
        >
          <DropdownToggle
            onlyIcon
            type={ButtonType.TONAL}
            size={ButtonSize.MEDIUM}
          >
            <ButtonIcon>
              <IconMenuKebab />
            </ButtonIcon>
          </DropdownToggle>
          <DropdownContent alignment={Direction.Right} width={200}>
            <ListContainer>{children}</ListContainer>
          </DropdownContent>
        </Dropdown>
      </MediumDown>

      {/* Action buttons displayed as row, (desktop) */}
      <DesktopOnly>
        <Row equallySizedChildren gap={0.5}>
          {children}
        </Row>
      </DesktopOnly>
    </>
  );
};
